import { clsx } from 'clsx'
import { type FC } from 'react'

import { IconCaretRight } from '@redteclab/icons'

import { Link } from 'base-ui'

import { apmCaptureError, apmSetCustomContext } from '../../../apm'
import { type SeoBreadcrumbListItem } from '../../../seo'
import { useProductPageContext } from '../productPageContext'

const getBreadcrumbItem = (
  breadcrumbItem: SeoBreadcrumbListItem,
): { link?: string; name: string } | null => {
  const { item: link, name } = breadcrumbItem

  if (typeof name === 'string') {
    if (typeof link === 'string') {
      return { link, name }
    }

    return { name }
  }
  apmSetCustomContext({
    breadcrumbItem,
  })
  apmCaptureError(
    new Error('Breadcrumb item has a wrong format for experiment'),
  )

  return null
}

export const ProductBreadcrumbsItems: FC = () => {
  const { breadcrumbs } = useProductPageContext()

  return breadcrumbs?.map((breadcrumbItem, index) => {
    const item = getBreadcrumbItem(breadcrumbItem)

    if (!item) {
      return null
    }
    const { link, name } = item
    const last = index === breadcrumbs.length - 1

    return (
      <span
        className={clsx(
          'hidden items-center gap-2 whitespace-nowrap first:flex mobile-sm:last:flex desktop:flex desktop:last:hidden',
          last && 'max-w-full overflow-hidden',
        )}
        key={name}
      >
        {index !== 0 && <IconCaretRight className="size-4 shrink-0" />}
        {link ? (
          <Link
            className={clsx(
              'capitalize no-underline hover:underline focus:underline',
              last && 'max-w-full overflow-hidden text-ellipsis',
            )}
            color="inherit"
            href={link}
          >
            {name}
          </Link>
        ) : (
          name
        )}
      </span>
    )
  })
}
